import { render } from "./AppNavbar.vue?vue&type=template&id=963d12c0&scoped=true"
import script from "./AppNavbar.vue?vue&type=script&lang=js"
export * from "./AppNavbar.vue?vue&type=script&lang=js"

import "./AppNavbar.vue?vue&type=style&index=0&id=963d12c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963d12c0"]])

export default __exports__